<template>
    <v-flex xs6 sm3 md2 lg1 class="pa-2">
        <v-card height="100%" class="flexcard" @contextmenu.prevent="openAdminMenu">
            <DocumentItemAdminMenu v-if="isCurrentUserAdmin" ref="adminMenu" :document="document"/>

            <v-img v-if="thumbnail" :src="thumbnail" :aspect-ratio="4/3" @click="showMedia"></v-img>
            <v-card-title v-else-if="isVideo" class="justify-center grow" @click="showMedia">
                <v-icon color="grey darken-3" class="tile-icon">ondemand_video</v-icon>
            </v-card-title>
            <v-card-title v-else class="justify-center grow" @click="download">
                <v-icon color="grey darken-3" class="tile-icon">attachment</v-icon>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-actions class="pa-3 font-weight-medium text-truncate justify-center">
                {{ document.name }}
            </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>
    import {mapGetters} from "vuex";
    import DocumentItemAdminMenu from "./DocumentItemAdminMenu";
    import {DOCUMENT_SHOW} from "../../store/actions.type";
    import {DocumentService} from "../../services/document.service";

    export default {
        name: "DocumentItem",
        components: {DocumentItemAdminMenu},
        props: {
            document: {
                type: Object,
                default: null
            },
            from: {
                type: String,
                default: null
            }
        },
        computed: {
            ...mapGetters(["isCurrentUserAdmin"]),
            documentSrc: function () {
                return process.env.VUE_APP_API_BASE_URL + this.document.path;
            },
            thumbnail: function () {
                return this.document.thumbnailPath ? process.env.VUE_APP_API_BASE_URL + this.document.thumbnailPath : null;
            },
            isVideo: function () {
                return DocumentService.isVideo(this.document);
            }
        },
        methods: {
            /**
             * Téléchargement d'un document
             */
            download: function () {
                window.open(this.documentSrc);
            },

            /**
             * Ouvre le menu d'admin
             */
            openAdminMenu: function (e) {
                if (this.isCurrentUserAdmin) {
                    this.$refs.adminMenu.open(e);
                }
            },

            /**
             * Affiche le media en fullscreen
             */
            showMedia: function () {
                this.$store.dispatch(DOCUMENT_SHOW, this.document.slug);
            }
        }
    };
</script>

<style scoped lang="scss">
    a {
        flex-grow: 1;
    }
</style>
